import { TabPassThroughMethodOptions } from "primevue/tab";

export default {
  root: ({ context }: TabPassThroughMethodOptions) => ({
    class: [
      'border-t-transparent',
      'rounded-b-none',

      // Spacing
      'h-12',
      '!px-1 mx-2 first:!ml-0',
      '-!mb-[0px]',
      '-mt-px',

      '!px-[0px]',

      // Flex and Alignment
      'flex items-center justify-center',

      'text-base font-semibold',
      {
        'bg-white ': !context.active,
        'border-b-2 border-transparent': !context.active,
        'border-b-2 border-b-blue-700': context.active,
        '!text-blue-700': context.active,
        'text-gray-500 dark:text-gray-400': !context.active,
      },
      {
        'hover:bg-white dark:hover:bg-surface-900': !context.active,
        'hover:!text-blue-700 dark:hover:!text-blue-700 hover:border-b-2 hover:border-b-blue-700': !context.active,
      },
    ],
  }),
};
